var _ModalHeader;
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalTitle, ModalFooter } from 'reaxl';
import FilterLocationForm from '../FilterLocationForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterLocationModal(_ref) {
  let {
    show = false,
    onHide = () => {},
    onSubmit = () => {},
    onOptionChange = () => {},
    filter = {},
    filters = {},
    errors = {},
    values = {},
    searchRadiusValue,
    zipValue,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(Modal, {
    "data-cmp": "filterLocation",
    show: show,
    onHide: onHide,
    bsSize: "small",
    ...rest,
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/_jsx(ModalHeader, {
      closeButton: true,
      children: /*#__PURE__*/_jsx(ModalTitle, {
        children: "Change your location"
      })
    })), /*#__PURE__*/_jsx(ModalBody, {
      children: /*#__PURE__*/_jsx(FilterLocationForm, {
        filter: filter,
        filters: filters,
        values: values,
        errors: errors,
        onOptionChange: onOptionChange,
        searchRadiusValue: searchRadiusValue,
        zipValue: zipValue
      })
    }), /*#__PURE__*/_jsxs(ModalFooter, {
      children: [/*#__PURE__*/_jsxs(Button, {
        onClick: onHide,
        children: [' ', "Cancel"]
      }), /*#__PURE__*/_jsxs(Button, {
        onClick: e => {
          onSubmit(e, onHide);
        },
        bsStyle: "primary",
        type: "submit",
        children: [' ', "Submit"]
      })]
    })]
  });
}
export default FilterLocationModal;